module.exports = __webpack_public_path__ + "img/icon-pengyouquan.411d71be.png";